import { Button, Header, Segment } from '@mairistem/composants';
import React from 'react';
import type ApercuNotePresentation from '../../../../interfaces/simulation/apercuNotePresentation';
import './NotePresentationViewer.css';

interface NotePresentationViewerProps {
	apercu: ApercuNotePresentation;
	onClose: VoidFunction;
}

const NotePresentationViewer = ({
	apercu: { documentNote, libelle },
	onClose,
}: NotePresentationViewerProps) => {
	const apercuRef = React.useRef<HTMLIFrameElement>(null);

	// Le document vit dans son propre contexte : l'impression ne porte que sur
	// lui, sans la mise en page de l'application
	const handleImprimer = () => {
		const apercuWindow = apercuRef.current?.contentWindow;

		apercuWindow?.focus();
		apercuWindow?.print();
	};

	return (
		<Segment basic className="notePresentationViewerPage" secondary>
			<Segment.Group className="notePresentationViewer">
				<Segment className="notePresentationViewerBarre" secondary>
					<Button
						content="Retour"
						data-testid="retourElaborationButton"
						onClick={onClose}
					/>
					<Header content={libelle} size="tiny" />
					<Button
						content="Imprimer / Enregistrer en PDF"
						data-testid="imprimerNoteButton"
						onClick={handleImprimer}
						positive
					/>
				</Segment>
				<Segment className="notePresentationViewerApercu">
					{/* Aucun composant de la librairie n'isole un document HTML :
					l'iframe évite que les styles de l'application déteignent sur la
					note */}
					<iframe
						className="notePresentationViewerDocument"
						data-testid="apercuNote"
						ref={apercuRef}
						srcDoc={documentNote}
						title={libelle}
					/>
				</Segment>
			</Segment.Group>
		</Segment>
	);
};

export default NotePresentationViewer;
